import { Suspense } from 'react';

import { getBrandPlaceData } from '@lib/server';
import { RTEContent } from '@types';

import { BlockBase } from '../utils';
import { AtreemoClientForm } from './client';

export interface AtreemoBlockData {
  contactDataSource: string;
  metadata?: {
    key: string;
    value: string;
  }[];
  additionalFields: AdditionalField[];
  marketingText?: string;
  thirdPartyOptIns?: { label: string; atreemoId: string }[];
  thirdPartyPolicies?: { label: RTEContent }[];
  useSelectedAsPreferred: boolean;
  successDialog?: { title?: string; message?: RTEContent };
}

export type AdditionalField = {
  type: string;
  label: string;
  atreemoId: string;
  placeholder?: string;
  required?: boolean;
};

export async function AtreemoForm({ params, ...data }: BlockBase & AtreemoBlockData) {
  const placesData = await getBrandPlaceData(decodeURIComponent(params.domain)).then((data) =>
    data.places.filter((place) => place.apps?.atreemo?.active),
  );

  if (!placesData.length) {
    return null;
  }

  return (
    <Suspense>
      <AtreemoClientForm
        {...data}
        places={placesData.filter((place) => (params.venue ? place.custom.slug === params.venue : true))}
      />
    </Suspense>
  );
}
